<template>
  <b-dropdown
    ref="dropdown"
    :disabled="loading"
    class="dropdown-custom action-item"
    right
  >
    <template #button-content>
      <i
        v-if="loading"
        class="fas fa-spinner spin"/>
      <i
        v-else
        class="fas fa-download"/>
      {{ $t('button.download') }}
    </template>
    <b-dropdown-item
      v-for="(item, index) in items"
      :key="index"
      @click="onSelect(item)"
    >
      {{ $t(item.text) }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: 'BaseDropdownFilterDownload',

  props: ['items', 'loading'],

  methods: {
    onSelect ({ text, value }) {
      this.$emit('onSelect', { text, value })
    },
  },
}
</script>

<style scoped>
.dropdown-custom /deep/ .dropdown-toggle,
.dropdown-custom.show /deep/ .dropdown-toggle {
  background: none;
  color: #6c757d;
  box-shadow: none;
}

.container-filter {
  min-width: 475px;
}

@media (max-width: 575.98px) {
  .container-filter {
    min-width: 350px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseDropdownFilterDownload.vue